import { render, staticRenderFns } from "./UserLogsView.vue?vue&type=template&id=441f56cc&scoped=true"
import script from "./UserLogsView.vue?vue&type=script&lang=js"
export * from "./UserLogsView.vue?vue&type=script&lang=js"
import style0 from "./UserLogsView.vue?vue&type=style&index=0&id=441f56cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441f56cc",
  null
  
)

export default component.exports